import { AnalyticsBrowser } from '@segment/analytics-next';
import { segmentId } from 'utils/general';

export const analytics = (id?: string) => {
    return AnalyticsBrowser.load({
        writeKey: id ? id : segmentId()
    });
};